// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"a4227c04","787":"3ce4cc4d"}[chunkId] + ".chunk.js";
};